export default __webpack_public_path__ + "static/media/EStore.fea77f1e.PNG";